import { Injectable } from '@angular/core';
import { Industry } from "../models/Industry.model";
import { HttpClient } from '../shared/wrappers/HttpClient';

@Injectable()
export class IndustriesService {

    constructor(private httpClient: HttpClient) { }

    endPoint: String = "/industries";

    async getAll(): Promise<Industry[]> {
        return await this.httpClient.get(this.endPoint);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/industries.service.ts